if ('customElements' in window && !customElements.get('hs-buy')) {
  class HeavenPurchase extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.form = this.querySelector('form');
      this.button = this.form?.querySelector('[name="add"]');
      if (!this.button) return;

      this.controller = new AbortController();
      this.label = this.button.querySelector('[data-button-label]');
      this.idleLabel = this.label.textContent;
      this.originalDisabled = this.button.disabled;
      this.error = this.form.querySelector('[data-buy-error]');
      this.cartLink = this.form.querySelector('[data-error-cart]');
      const options = { signal: this.controller.signal };
      this.form.addEventListener('submit', event => this.add(event), options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.setBusy(false);
      }, options);
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.busy) {
        this.setBusy(false);
        this.error.textContent = this.dataset.error;
        this.cartLink.hidden = false;
      }
      this.controller = null;
    }

    setBusy(busy) {
      this.busy = busy;
      this.button.disabled = busy || this.originalDisabled;
      this.form.setAttribute('aria-busy', String(busy));
      this.label.textContent = busy ? this.button.dataset.loading : this.idleLabel;
    }

    async add(event) {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      if (this.busy || this.originalDisabled) return;

      const data = new FormData(this.form);
      const signal = this.controller.signal;
      this.error.textContent = '';
      this.cartLink.hidden = true;
      this.setBusy(true);
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          signal
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        }
        if (!result.id && !result.items?.length) throw new Error(this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (signal.aborted) return;
        this.error.textContent = error instanceof TypeError || error instanceof SyntaxError ? this.dataset.error : error.message;
        this.cartLink.hidden = false;
        this.setBusy(false);
        this.button.focus();
      }
    }
  }
  customElements.define('hs-buy', HeavenPurchase);
}

if ('customElements' in window && !customElements.get('hs-related')) {
  class HeavenRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.controller || window.Shopify?.designMode || !window.IntersectionObserver) return;
      this.controller = new AbortController();
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load(this.controller.signal);
        }
      }, { rootMargin: '180px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }

    async load(signal) {
      try {
        const response = await fetch(this.dataset.url, { signal });
        if (!response.ok) return;
        const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('hs-related .com-section');
        if (next?.querySelector('.com-card') && !signal.aborted) this.replaceChildren(next);
      } catch {
        return;
      }
    }
  }
  customElements.define('hs-related', HeavenRecommendations);
}
